webpackJsonp([142354426033121],{

/***/ 907:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.MedicarePreparingYourPracticePage = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _medicare = __webpack_require__(49);
	
	var _globalStyles = __webpack_require__(4);
	
	var _resourceCard = __webpack_require__(30);
	
	var _comingSoon = __webpack_require__(468);
	
	var _tsd = __webpack_require__(433);
	
	var _tsd2 = _interopRequireDefault(_tsd);
	
	var _stethoscope = __webpack_require__(3721);
	
	var _stethoscope2 = _interopRequireDefault(_stethoscope);
	
	var _typeform = __webpack_require__(3722);
	
	var _typeform2 = _interopRequireDefault(_typeform);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MedicarePreparingYourPracticePage = function MedicarePreparingYourPracticePage() {
	  return _react2.default.createElement(
	    'div',
	    { className: _medicare.wrapperStyle },
	    _react2.default.createElement(
	      'section',
	      { className: (0, _globalStyles.contentSection)() },
	      _react2.default.createElement(
	        'div',
	        { className: _medicare.innerWrapperStyle },
	        _react2.default.createElement(
	          'h1',
	          { className: _medicare.titleStyle, style: { color: _globalStyles.purple } },
	          'Get Training'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _medicare.textStyle },
	          _react2.default.createElement(
	            'p',
	            null,
	            'All health professionals who plan to deliver services covered under the Eating Disorder Plan items must be appropriately trained. Our online training packages provide introductory training in treating eating disorders. We encourage interested clinicians to additionally access further specialised training and ongoing supervision.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Check out InsideOut\'s suite of eLearning courses ',
	            _react2.default.createElement(
	              'a',
	              { href: '/e-learning' },
	              'here'
	            ),
	            '.'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: (0, _globalStyles.contentSection)('#FFF') },
	      _react2.default.createElement(
	        'div',
	        { className: _medicare.innerWrapperStyle },
	        _react2.default.createElement(
	          'h1',
	          { className: _medicare.titleStyle },
	          'The Approved Psychological Treatments to be Delivered Under Medicare'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _medicare.textStyle },
	          _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	              'li',
	              null,
	              'Family Based Treatment for Eating Disorders (EDs) (including whole family, Parent Based Therapy, parent only or separated therapy)'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Adolescent Focused Therapy for EDs'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Cognitive Behavioural Therapy (CBT) for EDs (CBT-ED)'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'CBT-Anorexia Nervosa (AN) (CBT-AN)'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'CBT for Bulimia Nervosa (BN) and Binge-eating Disorder (BED) (CBT-BN and CBT BED)'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Specialist Supportive Clinical Management (SSCM) for EDs'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Maudsley Model of Anorexia Treatment in Adults (MANTRA)'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Interpersonal Therapy (IPT) for BN, BED'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Dialectical Behavioural Therapy (DBT) for BN, BED'
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: (0, _globalStyles.contentSection)() },
	      _react2.default.createElement(
	        'div',
	        { className: _medicare.innerWrapperStyle },
	        _react2.default.createElement(
	          'h1',
	          { className: _medicare.titleStyle },
	          'Training Required to Deliver Approved Treatments'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _medicare.textStyle },
	          'Our online training packages for mental health professionals and dietitians provide introductory training in treating eating disorders. Along with these introductory trainings you will need to demonstrate competency in the evidence based packages you deliver under the EDP.'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: (0, _globalStyles.contentSection)('#FFF') },
	      _react2.default.createElement(
	        'div',
	        { className: _medicare.innerWrapperStyle },
	        _react2.default.createElement(
	          'a',
	          { href: '/resource-library/the-essentials-training-clinicians-in-eating-disorders', style: { textDecoration: 'none' } },
	          _react2.default.createElement(_comingSoon.ComingSoon, {
	            title: 'The Essentials eLearning Program',
	            body: 'The only online program meeting the NEDC competency framework specified by Medicare.',
	            background: _globalStyles.blue,
	            image: _stethoscope2.default
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: { display: 'flex' } },
	          _react2.default.createElement(
	            'div',
	            { className: _medicare.resourceWrapper },
	            _react2.default.createElement(_resourceCard.ResourceCard, {
	              background: null,
	              to: '/resource-library/mbs-treatment-options-and-training',
	              audiences: [],
	              title: 'MBS Treatment Options and Training',
	              body: 'An overview of the services that can be provided under the MBS eating disorder items, associated readings and trainings for health professionals.',
	              date: '1 Nov, 2019'
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _medicare.resourceWrapper },
	            _react2.default.createElement(_resourceCard.ResourceCard, {
	              background: null,
	              to: '/events/save-the-date-cognitive-behavioural-therapy-for-bulimia-nervosa-and-binge-eating-disorder',
	              audiences: [],
	              title: 'CBT for Bulimia Nervosa and Binge Eating Disorder',
	              body: 'This 2-day workshop will provide a comprehensive introduction to Cognitive Behavioural Therapy (CBT), and an overview of key cognitive behavioural treatment concepts for Bulimia Nervosa/ Binge Eating Disorder (as per the Medicare items).',
	              date: '1 Nov, 2019'
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _medicare.resourceWrapper },
	            _react2.default.createElement(_resourceCard.ResourceCard, {
	              background: null,
	              to: '/resource-library/coming-soon-nutrition-management-of-eating-disorders-in-the-community',
	              audiences: [],
	              title: 'Dietitian Essentials: The Treatment of Eating Disorders',
	              body: 'This highly interactive program includes expert videos, case studies, quizzes and provides downloadable resources. The course is a beginner to intermediate practice-based program and takes approximately six hours to complete.',
	              date: '1 Nov, 2019'
	            })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: (0, _globalStyles.contentSection)() },
	      _react2.default.createElement(
	        'div',
	        { className: _medicare.innerWrapperStyle },
	        _react2.default.createElement(
	          'h1',
	          { className: _medicare.titleStyle, style: { color: _globalStyles.purple } },
	          'Get Listed'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _medicare.textStyle },
	          'Our Treatment Services Database is a national publicly available directory for health professionals with an interest in eating disorders. As such, a lot of people looking to receive care for an eating disorder use this service, and many organisations will be linking to our database to find practitioners.'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: (0, _globalStyles.contentSection)('#FFF') },
	      _react2.default.createElement(
	        'div',
	        { className: _medicare.innerWrapperStyle },
	        _react2.default.createElement(
	          'h1',
	          { className: _medicare.titleStyle },
	          'List yourself on our database'
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: { display: 'flex' } },
	          _react2.default.createElement(
	            'a',
	            { href: '/treatment-services' },
	            _react2.default.createElement('img', { src: _tsd2.default, alt: 'Treatment Services Database' })
	          ),
	          _react2.default.createElement(
	            'a',
	            { href: 'https://cedd.typeform.com/to/eJjefF' },
	            _react2.default.createElement('img', { src: _typeform2.default, alt: 'List yourself on our database', style: { height: '300px' } })
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.MedicarePreparingYourPracticePage = MedicarePreparingYourPracticePage;

/***/ }),

/***/ 908:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.MedicareForHealthProfessionalsStep1Page = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _medicare = __webpack_require__(49);
	
	var _globalStyles = __webpack_require__(4);
	
	var _edeq = __webpack_require__(766);
	
	var _edeq2 = _interopRequireDefault(_edeq);
	
	var _tsd = __webpack_require__(433);
	
	var _tsd2 = _interopRequireDefault(_tsd);
	
	var _resourceCard = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MedicareForHealthProfessionalsStep1Page = function MedicareForHealthProfessionalsStep1Page() {
	  return _react2.default.createElement(
	    'div',
	    { className: _medicare.wrapperStyle },
	    _react2.default.createElement(
	      'section',
	      { className: (0, _globalStyles.contentSection)(), style: { marginBottom: '150px' } },
	      _react2.default.createElement(
	        'div',
	        { className: _medicare.innerWrapperStyle },
	        _react2.default.createElement(
	          'h1',
	          { className: _medicare.titleStyle },
	          'Create an Eating Disorder Plan (EDP)'
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: { display: 'flex' } },
	          _react2.default.createElement(
	            'div',
	            { className: _medicare.textStyle },
	            _react2.default.createElement(
	              'p',
	              null,
	              '(trigger eating disorders pathway) 90250-90257 and 90260-90263'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'An eligible patient receives an eating disorder plan (EDP) developed by a medical practitioner in general practice (items 90250-90257), psychiatry (items 90260-90262) or paediatrics (items 90261-90263).'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: { minWidth: '250px', maxWidth: '250px' } },
	            _react2.default.createElement(
	              'div',
	              { style: { position: 'absolute' }, className: _medicare.resourceWrapper },
	              _react2.default.createElement(_resourceCard.ResourceCard, {
	                background: null,
	                to: '/resource-library/eating-disorder-care-plan',
	                audiences: [],
	                title: 'Eating Disorder Care Plan',
	                body: 'The medical practitioner can use this template to complete the Eating Disorder Care Plan',
	                date: '1 Nov, 2019'
	              })
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: (0, _globalStyles.contentSection)('#FFF') },
	      _react2.default.createElement(
	        'div',
	        { className: _medicare.innerWrapperStyle },
	        _react2.default.createElement(
	          'h1',
	          { className: _medicare.titleStyle },
	          'EDE-Q'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _medicare.textStyle },
	          'Your patients can do this online in your office and get a print out of their results, or you can print a hard copy below'
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: { display: 'flex', marginTop: '24px' } },
	          _react2.default.createElement(
	            'div',
	            { className: _medicare.resourceWrapper, style: { marginRight: '24px' } },
	            _react2.default.createElement(_resourceCard.ResourceCard, {
	              background: null,
	              to: '/resource-library/eating-disorder-examination-questionnaire-ede-q',
	              audiences: [],
	              title: 'EDE-Q',
	              body: 'This is a self-report version of the Eating Disorder Examination tool which assesses eating disorder pathology.',
	              date: '1 Nov, 2019'
	            })
	          ),
	          _react2.default.createElement(
	            'a',
	            { href: '/assessment?started=true' },
	            _react2.default.createElement('img', { src: _edeq2.default, style: { display: 'block', margin: '0 auto' }, alt: 'The EDE-Q assessment' })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: (0, _globalStyles.contentSection)() },
	      _react2.default.createElement(
	        'div',
	        { className: _medicare.innerWrapperStyle },
	        _react2.default.createElement(
	          'h1',
	          { className: _medicare.titleStyle },
	          'Referring Patients'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _medicare.textStyle },
	          'All health professionals who plan to deliver services covered under the EDP items must be appropriately trained.'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: (0, _globalStyles.contentSection)('#FFF') },
	      _react2.default.createElement(
	        'div',
	        { className: _medicare.innerWrapperStyle, style: { display: 'flex' } },
	        _react2.default.createElement(
	          'a',
	          { href: '/treatment-services' },
	          _react2.default.createElement('img', { src: _tsd2.default, alt: 'The treatment services database' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _medicare.textStyle, style: { marginLeft: '24px' } },
	          _react2.default.createElement(
	            'h1',
	            { className: _medicare.titleStyle, style: { color: _globalStyles.blue } },
	            'Find a Qualified Practitioner'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Building the right multidisciplinary team is an important part of quality care for eating disorders and has been incorporated into this new MBS model of treatment. Search for practitioners with a declared interest in eating disorders here.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'The Butterfly Foundation also have a phone line referral option: 1800 33 4673'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'ANZAED also has a search for practitioner function ',
	            _react2.default.createElement(
	              'a',
	              { href: 'https://www.xcdsystem.com/ANZAED/member_directory/' },
	              'here'
	            ),
	            '.'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: (0, _globalStyles.contentSection)('#FFF') },
	      _react2.default.createElement(
	        'div',
	        { className: _medicare.innerWrapperStyle },
	        _react2.default.createElement(
	          'div',
	          { className: _medicare.titleStyle, style: { color: _globalStyles.blue } },
	          'The Approved Psychological Treatments to be Delivered Under Medicare'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _medicare.textStyle },
	          _react2.default.createElement(
	            'p',
	            null,
	            'The psychological treatments strategies that are permitted under an EDP are:'
	          ),
	          _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	              'li',
	              null,
	              'Family Based Treatment for Eating Disorders (EDs) (including whole family, Parent Based Therapy, parent only or separated therapy)'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Adolescent Focused Therapy for EDs'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Cognitive Behavioural Therapy (CBT) for EDs (CBT-ED)'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'CBT-Anorexia Nervosa (AN) (CBT-AN)'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'CBT for Bulimia Nervosa (BN) and Binge-eating Disorder (BED) (CBT-BN and CBT BED)'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Specialist Supportive Clinical Management (SSCM) for EDs'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Maudsley Model of Anorexia Treatment in Adults (MANTRA)'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Interpersonal Therapy (IPT) for BN, BED'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Dialectical Behavioural Therapy (DBT) for BN, BED'
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.MedicareForHealthProfessionalsStep1Page = MedicareForHealthProfessionalsStep1Page;

/***/ }),

/***/ 909:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.MedicareForHealthProfessionalsStep2Page = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _person = __webpack_require__(236);
	
	var _person2 = _interopRequireDefault(_person);
	
	var _medicare = __webpack_require__(49);
	
	var _globalStyles = __webpack_require__(4);
	
	var _resourceCard = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MedicareForHealthProfessionalsStep2Page = function MedicareForHealthProfessionalsStep2Page() {
	  return _react2.default.createElement(
	    'div',
	    { className: _medicare.wrapperStyle },
	    _react2.default.createElement(
	      'section',
	      { className: (0, _globalStyles.contentSection)() },
	      _react2.default.createElement(
	        'div',
	        { className: _medicare.innerWrapperStyle },
	        _react2.default.createElement(
	          'h1',
	          { className: _medicare.titleStyle },
	          'Commence Initial Course of Treatment'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _medicare.textStyle },
	          _react2.default.createElement(
	            'p',
	            null,
	            '(Psychological & dietetic services)'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Once a patient has an EDP in place, the 12 month period commences. The patient can then access an initial course of 10 rebatable psychological sessions with an eligible mental health provider.  They can also access 20 dietetic sessions which they can either space across the 12 months or use more intensively in a shorter timeframe - this is a matter for the patient and their team to decide.  The remaining 30 psychological sessions can be approved by the GP in 10 session increments for those that require longer term therapy. A A psychiatrist or paediatrician review is required to open access to sessions 21-40.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'We encourage the GP to refer the patient to a psychiatrist or paediatrician (as relevant) early in the course of the EDP if it is thought that a patient will require more than 20 sessions, so that the specialist review can occur in a timely manner and not interrupt psychological treatment.'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: (0, _globalStyles.contentSection)() },
	      _react2.default.createElement(
	        'div',
	        { className: _medicare.innerWrapperStyle },
	        _react2.default.createElement(
	          'h1',
	          { className: _medicare.titleStyle },
	          'Returning to the GP'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _medicare.textStyle },
	          _react2.default.createElement(
	            'p',
	            null,
	            'Before the patient can receive the second group of 10 psychological treatment sessions they will need to return to the GP for a review and ongoing referral.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'It is required that the dietitian provide a letter to the GP following the initial assessment (after sessions 1 to 2) and recommended that the mental health provider do the same along with the required review at or before Session 10. Template letters are provided below. We encourage providers where possible and appropriate to send copies to other professionals involved in the patients\' care. We particularly suggest that mental health providers and dietitians are aware of the requirements of the specialist report and support the psychiatrist/paediatrician with this process by including any relevant information in their correspondance.  A factsheet on the specialist report can be found below.'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: (0, _globalStyles.contentSection)('#FFF') },
	      _react2.default.createElement(
	        'div',
	        { className: _medicare.innerWrapperStyle, style: { display: 'flex' } },
	        _react2.default.createElement(
	          'div',
	          { className: _medicare.resourceWrapper },
	          _react2.default.createElement(_resourceCard.ResourceCard, {
	            background: null,
	            to: '/resource-library/psychological-treatment-initial-report-template',
	            audiences: [],
	            title: 'Psychological Treatment Initial Report Template',
	            body: 'The psychological treatment provider can use this template for a report back to the medical practitioner following initial 1-2 sessions',
	            date: '1 Nov, 2019'
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _medicare.resourceWrapper },
	          _react2.default.createElement(_resourceCard.ResourceCard, {
	            background: null,
	            to: '/resource-library/dietetic-treatment-initial-report-template',
	            audiences: [],
	            title: 'Letter from Dietitian Session 1 or 2',
	            body: 'The dietitian can use this template for a report back to the medical practitioner following initial 1-2 sessions',
	            date: '1 Nov, 2019'
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _medicare.resourceWrapper },
	          _react2.default.createElement(_resourceCard.ResourceCard, {
	            background: null,
	            to: '/resource-library/psychological-treatment-review-template',
	            audiences: [],
	            title: 'Letter from Psych prior to Session 10',
	            body: 'The psychological treatment provider can use this template for a report back to the medical practitioner prior to care plan reviews at or before session 10, 20 and 30',
	            date: '1 Nov, 2019'
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _medicare.resourceWrapper },
	          _react2.default.createElement(_resourceCard.ResourceCard, {
	            background: null,
	            to: '/resource-library/the-specialist-review',
	            audiences: [],
	            title: 'The Specialist Review',
	            body: 'Summary of the formal specialist review by a consultant paediatrician or a consultant psychiatrist required to continue beyond 20 EDPT services.',
	            date: '1 Nov, 2019'
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _medicare.resourceWrapper },
	          _react2.default.createElement(_resourceCard.ResourceCard, {
	            background: null,
	            to: '/resource-library/gp-care-plan-review-template',
	            audiences: [],
	            title: 'GP Care Plan Review Template',
	            body: 'The medical practitioner can use this template to complete the Eating Disorder Care Plan Review at session 10, 20 and 30.',
	            date: '1 Nov, 2019'
	          })
	        )
	      )
	    )
	  );
	};
	
	exports.MedicareForHealthProfessionalsStep2Page = MedicareForHealthProfessionalsStep2Page;

/***/ }),

/***/ 910:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.MedicareForHealthProfessionalsStep3Page = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _person = __webpack_require__(236);
	
	var _person2 = _interopRequireDefault(_person);
	
	var _medicare = __webpack_require__(49);
	
	var _globalStyles = __webpack_require__(4);
	
	var _resourceCard = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MedicareForHealthProfessionalsStep3Page = function MedicareForHealthProfessionalsStep3Page() {
	  return _react2.default.createElement(
	    'div',
	    { className: _medicare.wrapperStyle },
	    _react2.default.createElement(
	      'section',
	      { className: (0, _globalStyles.contentSection)() },
	      _react2.default.createElement(
	        'div',
	        { className: _medicare.innerWrapperStyle },
	        _react2.default.createElement(
	          'h1',
	          { className: _medicare.titleStyle },
	          'Formal Specialist and Practitioner Review'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _medicare.textStyle },
	          _react2.default.createElement(
	            'p',
	            null,
	            '90266-90269 (continue beyond 20 EDPT services)'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'A patient must have two additional reviews before they can access more than 20 EDP psychological services. A psychiatrist or paediatritian must assess the patient and provide a report confirming the diagnosis at the initiation of the EDP, evaluate treatment progress and make a recommendation as to whether or not further psychological sessions are needed.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'We suggest that the mental health provider who has been delivering the psychological sessions, and if relevant the dietitian, provide a written report to both the psychiatrist/paediatritian and the GP prior to their reviews to make the case for further treatment if it is needed.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'The treating dietitian provides an end of treatment letter to the GP at or before Session 20.'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: (0, _globalStyles.contentSection)('#FFF') },
	      _react2.default.createElement(
	        'div',
	        { className: _medicare.innerWrapperStyle, style: { display: 'flex' } },
	        _react2.default.createElement(
	          'div',
	          { className: _medicare.resourceWrapper },
	          _react2.default.createElement(_resourceCard.ResourceCard, {
	            background: null,
	            to: '/resource-library/psychological-treatment-review-template',
	            audiences: [],
	            title: 'Psychological Treatment Review Template',
	            body: 'The psychological treatment provider can use this template for a report back to the medical practitioner prior to care plan reviews at or before session 10, 20 and 30',
	            date: '1 Nov, 2019'
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _medicare.resourceWrapper },
	          _react2.default.createElement(_resourceCard.ResourceCard, {
	            background: null,
	            to: '/resource-library/dietetic-end-of-treatment-report-template',
	            audiences: [],
	            title: 'Dietetic End of Treatment Report Template',
	            body: 'The dietitian can use this template for a report back to the medical practitioner following the completion of treatment under the Eating Disorder Care Plan whether this occurs at or before 20 sessions.',
	            date: '1 Nov, 2019'
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _medicare.resourceWrapper },
	          _react2.default.createElement(_resourceCard.ResourceCard, {
	            background: null,
	            to: '/resource-library/the-specialist-review',
	            audiences: [],
	            title: 'The Specialist Report',
	            body: 'Summary of the formal specialist review by a consultant paediatrician or a consultant psychiatrist required to continue beyond 20 EDPT services.',
	            date: '1 Nov, 2019'
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _medicare.resourceWrapper },
	          _react2.default.createElement(_resourceCard.ResourceCard, {
	            background: null,
	            to: '/resource-library/gp-care-plan-review-template',
	            audiences: [],
	            title: 'GP Care Plan Review Template',
	            body: 'The medical practitioner can use this template to complete the Eating Disorder Care Plan Review at session 10, 20 and 30.',
	            date: '1 Nov, 2019'
	          })
	        )
	      )
	    )
	  );
	};
	
	exports.MedicareForHealthProfessionalsStep3Page = MedicareForHealthProfessionalsStep3Page;

/***/ }),

/***/ 911:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.MedicareForHealthProfessionalsStep4Page = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _person = __webpack_require__(236);
	
	var _person2 = _interopRequireDefault(_person);
	
	var _medicare = __webpack_require__(49);
	
	var _globalStyles = __webpack_require__(4);
	
	var _resourceCard = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MedicareForHealthProfessionalsStep4Page = function MedicareForHealthProfessionalsStep4Page() {
	  return _react2.default.createElement(
	    'div',
	    { className: _medicare.wrapperStyle },
	    _react2.default.createElement(
	      'section',
	      { className: (0, _globalStyles.contentSection)() },
	      _react2.default.createElement(
	        'div',
	        { className: _medicare.innerWrapperStyle },
	        _react2.default.createElement(
	          'h1',
	          { className: _medicare.titleStyle },
	          'Access to Maximum Intensity of Treatment'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _medicare.textStyle },
	          _react2.default.createElement(
	            'p',
	            null,
	            '90266-90269 (continue beyond 30 EDPT services)'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'To access more than 30 EDPT treatment services in the 12 month period, patients are required to have an additional GP review (the \u2018fourth review\u2019) to ensure the highest intensity of treatment is appropriate. Subject to this review, a patient can access the maximum of 40 EDPT treatment services in a 12 month period. Again, the mental health professional is required to provide a report to the GP prior to this review.'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: (0, _globalStyles.contentSection)('#FFF') },
	      _react2.default.createElement(
	        'div',
	        { className: _medicare.innerWrapperStyle, style: { display: 'flex' } },
	        _react2.default.createElement(
	          'div',
	          { className: _medicare.resourceWrapper },
	          _react2.default.createElement(_resourceCard.ResourceCard, {
	            background: null,
	            to: '/resource-library/psychological-treatment-review-template',
	            audiences: [],
	            title: 'Letter from Psych Session 30',
	            body: 'The psychological treatment provider can use this template for a report back to the medical practitioner prior to care plan reviews at or before session 10, 20 and 30',
	            date: '1 Nov, 2019'
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _medicare.resourceWrapper },
	          _react2.default.createElement(_resourceCard.ResourceCard, {
	            background: null,
	            to: '/resource-library/gp-care-plan-review-template',
	            audiences: [],
	            title: 'GP Care Plan Review Template',
	            body: 'The medical practitioner can use this template to complete the Eating Disorder Care Plan Review at session 10, 20 and 30.',
	            date: '1 Nov, 2019'
	          })
	        )
	      )
	    )
	  );
	};
	
	exports.MedicareForHealthProfessionalsStep4Page = MedicareForHealthProfessionalsStep4Page;

/***/ }),

/***/ 912:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.MedicareForHealthProfessionalsStep5Page = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _person = __webpack_require__(236);
	
	var _person2 = _interopRequireDefault(_person);
	
	var _medicare = __webpack_require__(49);
	
	var _globalStyles = __webpack_require__(4);
	
	var _resourceCard = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MedicareForHealthProfessionalsStep5Page = function MedicareForHealthProfessionalsStep5Page() {
	  return _react2.default.createElement(
	    'div',
	    { className: _medicare.wrapperStyle },
	    _react2.default.createElement(
	      'section',
	      { className: (0, _globalStyles.contentSection)() },
	      _react2.default.createElement(
	        'div',
	        { className: _medicare.innerWrapperStyle },
	        _react2.default.createElement(
	          'h1',
	          { className: _medicare.titleStyle },
	          'End of Treatment'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _medicare.textStyle },
	          _react2.default.createElement(
	            'p',
	            null,
	            '90266-90269 (continue beyond 30 EDPT services)'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'At the end of treatment the mental health provider and the dietitian must provide a report back to the GP. You can find an example template for that report below.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Patients will be eligible for another EDP with the same therapy and dietetic allowances 12 months after the initiation of the first plan (it does not run by calendar year but rather from the date the plan was issued).'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Patients may continue treatment with their psychological providers and dietitians without an active EDP but the sessions will not be rebated under MBS.'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: (0, _globalStyles.contentSection)('#FFF') },
	      _react2.default.createElement(
	        'div',
	        { className: _medicare.innerWrapperStyle, style: { display: 'flex' } },
	        _react2.default.createElement(
	          'div',
	          { className: _medicare.resourceWrapper },
	          _react2.default.createElement(_resourceCard.ResourceCard, {
	            background: null,
	            to: '/resource-library/psychological-treatment-end-of-treatment-report-template',
	            audiences: [],
	            title: 'Psychological Treatment End of Treatment Report Template',
	            body: 'The psychological treatment provider can use this template for a report back to the medical practitioner following the completion of treatment under the Eating Disorder Care Plan whether this occurs at or before 40 sessions.',
	            date: '1 Nov, 2019'
	          })
	        )
	      )
	    )
	  );
	};
	
	exports.MedicareForHealthProfessionalsStep5Page = MedicareForHealthProfessionalsStep5Page;

/***/ }),

/***/ 446:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.StepSelect = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styles = __webpack_require__(372);
	
	var _medicare = __webpack_require__(49);
	
	var _globalStyles = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function StepCard(_ref) {
	  var title = _ref.title,
	      onClick = _ref.onClick,
	      color = _ref.color,
	      active = _ref.active;
	
	  return _react2.default.createElement(
	    'div',
	    { onClick: onClick, style: { background: active && color || _globalStyles.lightGrey }, className: _styles.stepCardStyle },
	    title
	  );
	}
	
	function StepSelect(_ref2) {
	  var step = _ref2.step,
	      setStep = _ref2.setStep,
	      color = _ref2.color;
	
	  return _react2.default.createElement(
	    'section',
	    { className: _styles.cardsStyle },
	    _react2.default.createElement(
	      'div',
	      { className: _medicare.innerWrapperStyle, style: { display: 'flex', overflowX: 'visible' } },
	      _react2.default.createElement(StepCard, {
	        onClick: function onClick() {
	          return setStep(1);
	        },
	        title: 'Initiating Treatment',
	        color: color,
	        active: step === 1
	      }),
	      _react2.default.createElement(StepCard, {
	        onClick: function onClick() {
	          return setStep(2);
	        },
	        title: 'Sessions 1-10',
	        color: color,
	        active: step === 2
	      }),
	      _react2.default.createElement(StepCard, {
	        onClick: function onClick() {
	          return setStep(3);
	        },
	        title: 'Sessions 11-20',
	        color: color,
	        active: step === 3
	      }),
	      _react2.default.createElement(StepCard, {
	        onClick: function onClick() {
	          return setStep(4);
	        },
	        title: 'Sessions 21-30',
	        color: color,
	        active: step === 4
	      }),
	      _react2.default.createElement(StepCard, {
	        onClick: function onClick() {
	          return setStep(5);
	        },
	        title: 'Sessions 31-40',
	        color: color,
	        active: step === 5
	      })
	    )
	  );
	}
	
	exports.StepSelect = StepSelect;

/***/ }),

/***/ 372:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.stepCardStyle = exports.cardsStyle = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _emotion = __webpack_require__(6);
	
	var _globalStyles = __webpack_require__(4);
	
	var cardsStyle = /*#__PURE__*/exports.cardsStyle = (0, _emotion.css)({
	  marginBottom: '150px',
	  positon: 'relative',
	  zIndex: '1'
	});
	
	var stepCardStyle = /*#__PURE__*/exports.stepCardStyle = (0, _emotion.css)(_extends({}, _globalStyles.museo900, {
	  position: 'relative',
	  borderRadius: '8px',
	  boxShadow: '0 6px 12px 0 rgba(0,0,0,0.18)',
	  padding: '36px 24px',
	  margin: '0 24px',
	  '&:hover': {
	    transform: 'translateY(-4px)',
	    boxShadow: '0 8px 12px 0 rgba(0,0,0,0.4)'
	  }
	}));

/***/ }),

/***/ 467:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ComingSoon = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styles = __webpack_require__(469);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ComingSoon = exports.ComingSoon = function (_React$Component) {
		_inherits(ComingSoon, _React$Component);
	
		function ComingSoon() {
			_classCallCheck(this, ComingSoon);
	
			return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
		}
	
		ComingSoon.prototype.render = function render() {
			var _props = this.props,
			    image = _props.image,
			    imageWidth = _props.imageWidth,
			    title = _props.title,
			    body = _props.body,
			    background = _props.background;
	
			return _react2.default.createElement(
				'div',
				{ className: (0, _styles.wrapperStyle)(background) },
				_react2.default.createElement('img', { src: image, alt: '', width: imageWidth, className: _styles.imageStyle }),
				_react2.default.createElement(
					'div',
					{ className: _styles.contentStyle },
					_react2.default.createElement(
						'p',
						{ className: _styles.titleStyle },
						title
					),
					_react2.default.createElement(
						'p',
						{ className: _styles.bodyStyle },
						body
					)
				)
			);
		};
	
		return ComingSoon;
	}(_react2.default.Component);
	
	ComingSoon.propTypes = {
		image: _propTypes2.default.string,
		imageWidth: _propTypes2.default.number,
		title: _propTypes2.default.string,
		body: _propTypes2.default.string,
		background: _propTypes2.default.string
	};

/***/ }),

/***/ 468:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _component = __webpack_require__(467);
	
	Object.keys(_component).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _component[key];
	    }
	  });
	});

/***/ }),

/***/ 469:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.bodyStyle = exports.titleStyle = exports.contentStyle = exports.imageStyle = exports.wrapperStyle = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _css2, _css3, _extends2, _css4;
	
	var _emotion = __webpack_require__(6);
	
	var _globalStyles = __webpack_require__(4);
	
	var wrapperStyle = exports.wrapperStyle = function wrapperStyle(background) {
		var _css;
	
		return (/*#__PURE__*/(0, _emotion.css)((_css = {
				background: background,
				display: 'flex',
				width: '100%',
				height: '160px',
				borderRadius: '6px',
				margin: '12px'
			}, _css['@media (max-width: ' + _globalStyles.tabletPortraitMaxWidthBreakpoint + 'px)'] = {
				height: 'auto'
			}, _css))
		);
	};
	
	var imageStyle = /*#__PURE__*/exports.imageStyle = (0, _emotion.css)((_css2 = {}, _css2['@media (max-width: ' + _globalStyles.tabletPortraitMaxWidthBreakpoint + 'px)'] = {
		display: 'none'
	}, _css2));
	
	var contentStyle = /*#__PURE__*/exports.contentStyle = (0, _emotion.css)((_css3 = {
		padding: '30px'
	}, _css3['@media (max-width: ' + _globalStyles.tabletPortraitMaxWidthBreakpoint + 'px)'] = {
		padding: '24px 10px'
	}, _css3));
	
	var titleStyle = /*#__PURE__*/exports.titleStyle = (0, _emotion.css)(_extends({}, _globalStyles.museo900, (_extends2 = {
		fontSize: '12px',
		lineHeight: '14px',
		margin: '0 0 5px 0',
		color: '#fff',
		textTransform: 'uppercase'
	}, _extends2['@media (max-width: ' + _globalStyles.tabletPortraitMaxWidthBreakpoint + 'px)'] = {
		marginBottom: '13px'
	}, _extends2)));
	
	var bodyStyle = exports.bodyStyle = (0, _emotion.cx)(_globalStyles.headingLarge, /*#__PURE__*/(0, _emotion.css)((_css4 = {
		color: '#fff'
	}, _css4['@media (max-width: ' + _globalStyles.tabletLandscapeMaxWidthBreakpoint + 'px)'] = {
		fontSize: '30px',
		lineHeight: '36px'
	}, _css4['@media (max-width: ' + _globalStyles.tabletPortraitMaxWidthBreakpoint + 'px)'] = {
		fontSize: '20px',
		lineHeight: '24px'
	}, _css4)));

/***/ }),

/***/ 766:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/edeq.041218ce.png";

/***/ }),

/***/ 767:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 236:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/person-1.9f15fd84.png";

/***/ }),

/***/ 3721:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/stethoscope.0152486c.png";

/***/ }),

/***/ 433:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/tsd.65cba321.png";

/***/ }),

/***/ 3722:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/typeform.261ace20.png";

/***/ }),

/***/ 1106:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(8);
	
	var _link = __webpack_require__(9);
	
	var _cards = __webpack_require__(17);
	
	var _resourceCard = __webpack_require__(30);
	
	var _step = __webpack_require__(908);
	
	var _step2 = __webpack_require__(909);
	
	var _step3 = __webpack_require__(910);
	
	var _step4 = __webpack_require__(911);
	
	var _step5 = __webpack_require__(912);
	
	var _preparingYourPractice = __webpack_require__(907);
	
	var _stepSelect = __webpack_require__(446);
	
	var _faq = __webpack_require__(767);
	
	var _faq2 = _interopRequireDefault(_faq);
	
	var _medicare = __webpack_require__(49);
	
	var _globalStyles = __webpack_require__(4);
	
	var _styles = __webpack_require__(372);
	
	var _myselfBg = __webpack_require__(366);
	
	var _myselfBg2 = _interopRequireDefault(_myselfBg);
	
	var _healthProfessionalBg = __webpack_require__(434);
	
	var _healthProfessionalBg2 = _interopRequireDefault(_healthProfessionalBg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function MedicareForHealthProfessionalsPage() {
	  var _useState = (0, _react.useState)(0),
	      step = _useState[0],
	      setStep = _useState[1];
	
	  var _useState2 = (0, _react.useState)(false),
	      preparing = _useState2[0],
	      setPreparing = _useState2[1];
	
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      { title: 'Medicare for Health Professionals' },
	      _react2.default.createElement('meta', { property: 'og:type', content: 'website' }),
	      _react2.default.createElement('meta', { property: 'og:title', content: 'Medicare for Health Professionals' }),
	      _react2.default.createElement('meta', { name: 'description', content: 'Medicare for Health Professionals' }),
	      _react2.default.createElement('meta', { property: 'og:description', content: 'Medicare for Health Professionals' })
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: (0, _globalStyles.contentSection)('#fff') },
	      _react2.default.createElement(
	        'div',
	        { className: _medicare.innerWrapperStyle },
	        _react2.default.createElement(
	          'h1',
	          { className: _medicare.titleStyle, style: { color: _globalStyles.blue } },
	          'Medicare for Health Professionals'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _medicare.textStyle },
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'a',
	              { rel: 'noopener noreferrer', target: '_blank', href: 'https://insideoutinstitute.org.au/resource-library/medicare-clinician-faqs' },
	              _react2.default.createElement('img', { src: _faq2.default, alt: 'FAQ link' })
	            ),
	            '.'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: (0, _medicare.videoSection)(_globalStyles.blue) },
	      _react2.default.createElement(
	        'div',
	        { className: _medicare.videoDiv },
	        _react2.default.createElement(
	          'div',
	          null,
	          'How does it work?'
	        ),
	        _react2.default.createElement('iframe', { src: 'https://player.vimeo.com/video/369493029', width: '640', height: '360', frameBorder: '0', allow: 'autoplay; fullscreen', allowFullScreen: true }),
	        _react2.default.createElement(
	          'div',
	          { style: { width: '250px', position: 'absolute' } },
	          _react2.default.createElement(_resourceCard.ResourceCard, {
	            background: null,
	            to: '/resource-library/mbs-eating-disorder-items',
	            audiences: [],
	            title: 'Medicare Items Summary',
	            body: 'Medicare item numbers for the suite of new items.',
	            date: '1 Nov, 2019'
	          })
	        )
	      )
	    ),
	    _react2.default.createElement(_stepSelect.StepSelect, { step: step, setStep: setStep, color: _globalStyles.blue }),
	    step === 1 && _react2.default.createElement(_step.MedicareForHealthProfessionalsStep1Page, null),
	    step === 2 && _react2.default.createElement(_step2.MedicareForHealthProfessionalsStep2Page, null),
	    step === 3 && _react2.default.createElement(_step3.MedicareForHealthProfessionalsStep3Page, null),
	    step === 4 && _react2.default.createElement(_step4.MedicareForHealthProfessionalsStep4Page, null),
	    step === 5 && _react2.default.createElement(_step5.MedicareForHealthProfessionalsStep5Page, null),
	    _react2.default.createElement(
	      'section',
	      { className: (0, _globalStyles.contentSection)('#FFF') },
	      _react2.default.createElement(
	        'div',
	        { className: _medicare.innerWrapperStyle, style: { overflowX: 'visible' } },
	        _react2.default.createElement(
	          'div',
	          { onClick: function onClick() {
	              return setPreparing(!preparing);
	            }, style: { background: preparing && _globalStyles.purple || _globalStyles.lightGrey, width: '400px' }, className: _styles.stepCardStyle },
	          'Get Training'
	        )
	      )
	    ),
	    preparing && _react2.default.createElement(_preparingYourPractice.MedicarePreparingYourPracticePage, null)
	  );
	}
	
	exports.default = MedicareForHealthProfessionalsPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-medicare-for-health-professionals-index-js-a8b883c88bdf3b48404e.js